<div class="create-container">
    <div class="create-card">

        <!-- ==================== VISTA LISTADO ==================== -->
        @if (viewMode === 'list') {
        <div class="list-header">
            <h2>Fichas</h2>
            <button class="form-btn new-btn" (click)="showForm()">+</button>
        </div>

        <!-- Filtros -->
        <div class="filters-box">
            <div class="filter-radios">
                @for (cat of categorias; track cat.value) {
                <label class="radio-chip" [class.active]="filterCategory === cat.value"
                    (click)="setFilterCategory(cat.value)">
                    {{ cat.label }}
                </label>
                }
            </div>
            <input type="text" class="form-input search-input" placeholder="Buscar por nombre..."
                [(ngModel)]="filterText" (input)="applyFilters()">
        </div>

        <!-- Lista -->
        @if (isLoading) {
        <div class="list-loading">
            <div class="spinner"></div>
        </div>
        } @else {
        <div class="list-results">
            <span class="list-count">{{ filteredFeatures.length }} resultados</span>
        </div>
        <div class="list-table">
            @for (item of filteredFeatures; track item.OBJECTID) {
            <div class="list-row">
                <span class="list-cat-badge" [attr.data-cat]="item.categoria">{{
                    getCategoriaLabel(item.categoria) }}</span>
                <span class="list-name">{{ item.denominacion }}</span>
                <span class="list-id">#{{ item.OBJECTID }}</span>
                <button class="inspect-btn" type="button" (click)="openInspectModal(item)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                        <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                </button>
                <button class="delete-btn" type="button" (click)="openDeleteModal(item)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="3 6 5 6 21 6"></polyline>
                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                        <path d="M10 11v6"></path>
                        <path d="M14 11v6"></path>
                        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                    </svg>
                </button>
            </div>
            } @empty {
            <div class="list-empty">No se encontraron fichas.</div>
            }
        </div>
        }
        }

        <!-- ==================== VISTA FORMULARIO ==================== -->
        @if (viewMode === 'form') {
        <div class="create-header">
            <button type="button" class="back-link" (click)="backToList()">← Volver al listado</button>
            <h2>Crear nueva maravilla</h2>
            <div class="progress-indicator">
                <span class="step-text">{{ sectionTitles[currentStep] }}</span>
                <span class="step-count">{{ currentStep + 1 }}/{{ totalSteps }}</span>
            </div>
            <div class="progress-bar-bg">
                <div class="progress-bar-fill" [style.width.%]="((currentStep + 1) / totalSteps) * 100"></div>
            </div>
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">

            <!-- PASO 1: Categoría y datos generales -->
            @if (currentStep === 0) {
            <div class="section-content">
                <div class="form-field">
                    <label class="required">Categoría</label>
                    <div class="select-wrapper">
                        <select formControlName="categoria" class="form-input">
                            <option value="" disabled>Selecciona una categoría</option>
                            @for (cat of categorias; track cat.value) {
                            <option [value]="cat.value">{{ cat.label }}</option>
                            }
                        </select>
                    </div>
                    @if (form.get('categoria')?.invalid && form.get('categoria')?.touched) {
                    <div class="error">Este campo es obligatorio</div>
                    }
                </div>

                <div class="form-field">
                    <label class="required">Nombre (Español)</label>
                    <input type="text" formControlName="denominacion_esp" class="form-input"
                        placeholder="Ej: Playa de la Concha">
                    @if (form.get('denominacion_esp')?.invalid && form.get('denominacion_esp')?.touched) {
                    <div class="error">Este campo es obligatorio</div>
                    }
                </div>

                <div class="form-field">
                    <label class="required">Nombre (Inglés)</label>
                    <input type="text" formControlName="denominacion_ing" class="form-input"
                        placeholder="Ej: La Concha Beach">
                    @if (form.get('denominacion_ing')?.invalid && form.get('denominacion_ing')?.touched) {
                    <div class="error">Este campo es obligatorio</div>
                    }
                </div>
            </div>
            }

            <!-- PASO 2: Ubicación -->
            @if (currentStep === 1) {
            <div class="section-content">
                <div class="form-field">
                    <label class="required">Enlace Google Maps</label>
                    <input type="text" formControlName="enlace_maps" class="form-input"
                        placeholder="https://www.google.com/maps/place/.../@28.131,-15.432,17z/...">
                    @if (form.get('enlace_maps')?.invalid && form.get('enlace_maps')?.touched) {
                    <div class="error">Este campo es obligatorio</div>
                    }
                    <p class="field-hint">Pega la URL completa de Google Maps. Las coordenadas se extraerán
                        automáticamente.</p>
                </div>

                <div class="url-actions">
                    <button type="button" class="form-btn" (click)="generateCoords()">
                        Generar coordenadas
                    </button>
                    <button type="button" class="form-btn secondary-btn" (click)="clearUrl()">
                        Limpiar URL
                    </button>
                </div>

                @if (coordError) {
                <div class="error-box">{{ coordError }}</div>
                }

                <div class="coords-row">
                    <div class="form-field">
                        <label>Latitud</label>
                        <input type="text" formControlName="latitud" class="form-input coord-input" readonly
                            placeholder="Se genera automáticamente">
                    </div>
                    <div class="form-field">
                        <label>Longitud</label>
                        <input type="text" formControlName="longitud" class="form-input coord-input" readonly
                            placeholder="Se genera automáticamente">
                    </div>
                </div>
            </div>
            }

            <!-- PASO 3: Descripciones -->
            @if (currentStep === 2) {
            <div class="section-content">
                <div class="form-field">
                    <label class="required">Descripción (Español)</label>
                    <textarea formControlName="descripcion_esp" class="form-input form-textarea" rows="4"
                        placeholder="Descripción detallada en español..."></textarea>
                    @if (form.get('descripcion_esp')?.invalid && form.get('descripcion_esp')?.touched) {
                    <div class="error">Este campo es obligatorio</div>
                    }
                </div>

                <div class="form-field">
                    <label class="required">Descripción (Inglés)</label>
                    <textarea formControlName="descripcion_ing" class="form-input form-textarea" rows="4"
                        placeholder="Detailed description in English..."></textarea>
                    @if (form.get('descripcion_ing')?.invalid && form.get('descripcion_ing')?.touched) {
                    <div class="error">Este campo es obligatorio</div>
                    }
                </div>

                <div class="form-field">
                    <label>Resumen informativo (Español)</label>
                    <textarea formControlName="resumen_esp" class="form-input form-textarea" rows="2"
                        placeholder="Breve resumen en español..."></textarea>
                </div>

                <div class="form-field">
                    <label>Resumen informativo (Inglés)</label>
                    <textarea formControlName="resumen_ing" class="form-input form-textarea" rows="2"
                        placeholder="Short summary in English..."></textarea>
                </div>

                <div class="form-field">
                    <label>Observaciones</label>
                    <textarea formControlName="obs" class="form-input form-textarea" rows="2"
                        placeholder="Notas internas u observaciones..."></textarea>
                </div>
            </div>
            }

            <!-- PASO 4: Campos específicos de playa -->
            @if (currentStep === 3 && form.get('categoria')?.value === 'playa') {
            <div class="section-content">
                <div class="form-field">
                    <label>Tipo de playa</label>
                    <div class="select-wrapper">
                        <select formControlName="playa_piedra_esp" class="form-input">
                            <option value="">Selecciona tipo</option>
                            @for (opt of tiposPlaya; track opt.value) {
                            <option [value]="opt.value">{{ opt.label }}</option>
                            }
                        </select>
                    </div>
                </div>

                <div class="form-field">
                    <label>Peligrosidad</label>
                    <div class="select-wrapper">
                        <select formControlName="peligrosidad_esp" class="form-input">
                            <option value="">Selecciona nivel</option>
                            @for (opt of peligrosidades; track opt.value) {
                            <option [value]="opt.value">{{ opt.label }}</option>
                            }
                        </select>
                    </div>
                </div>

                <div class="toggle-grid">
                    <label class="toggle-card" [class.active]="form.get('duchas')?.value === 'true'">
                        <span class="toggle-label">Duchas</span>
                        <div class="toggle-switch" (click)="toggleField('duchas')">
                            <div class="toggle-knob"></div>
                        </div>
                    </label>

                    <label class="toggle-card" [class.active]="form.get('restauracion')?.value === 'true'">
                        <span class="toggle-label">Restauración en la playa</span>
                        <div class="toggle-switch" (click)="toggleField('restauracion')">
                            <div class="toggle-knob"></div>
                        </div>
                    </label>

                    <label class="toggle-card" [class.active]="form.get('parking')?.value === 'true'">
                        <span class="toggle-label">Parking</span>
                        <div class="toggle-switch" (click)="toggleField('parking')">
                            <div class="toggle-knob"></div>
                        </div>
                    </label>

                    <label class="toggle-card" [class.active]="form.get('accesible')?.value === 'true'">
                        <span class="toggle-label">Accesible para minusválidos</span>
                        <div class="toggle-switch" (click)="toggleField('accesible')">
                            <div class="toggle-knob"></div>
                        </div>
                    </label>
                </div>

                @if (form.get('parking')?.value === 'true') {
                <div class="form-field">
                    <label>Descripción del parking (Español)</label>
                    <input type="text" formControlName="descripcion_parking_esp" class="form-input"
                        placeholder="Ej: Zona de aparcamiento gratuita a 100 metros">
                </div>
                <div class="form-field">
                    <label>Descripción del parking (Inglés)</label>
                    <input type="text" formControlName="descripcion_parking_ing" class="form-input"
                        placeholder="Ej: Free parking area 100 meters away">
                </div>
                }
            </div>
            }

            <!-- PASO 4: Campos específicos de arquitectura -->
            @if (currentStep === 3 && form.get('categoria')?.value === 'arq') {
            <div class="section-content">
                <div class="form-field">
                    <label>Precio de entrada</label>
                    <input type="number" formControlName="arq_precio_entrada" class="form-input"
                        placeholder="0 si es gratuito" min="0" step="0.01">
                    <p class="field-hint">Introduce 0 si la entrada es gratuita.</p>
                </div>

                <div class="form-field">
                    <label>Horario (Español)</label>
                    <input type="text" formControlName="arq_horario_esp" class="form-input"
                        placeholder="Ej: Lunes a viernes de 10:00 a 18:00">
                </div>

                <div class="form-field">
                    <label>Horario (Inglés)</label>
                    <input type="text" formControlName="arq_horario_ing" class="form-input"
                        placeholder="Ej: Monday to Friday from 10:00 to 18:00">
                </div>

                <div class="form-field">
                    <label>Historia (Español)</label>
                    <textarea formControlName="arq_historia_esp" class="form-input form-textarea" rows="3"
                        placeholder="Historia o contexto del lugar en español..."></textarea>
                </div>

                <div class="form-field">
                    <label>Historia (Inglés)</label>
                    <textarea formControlName="arq_historia_ing" class="form-input form-textarea" rows="3"
                        placeholder="History or context of the place in English..."></textarea>
                </div>

                <div class="toggle-grid">
                    <label class="toggle-card" [class.active]="form.get('arq_parking')?.value === 'true'">
                        <span class="toggle-label">Parking</span>
                        <div class="toggle-switch" (click)="toggleField('arq_parking')">
                            <div class="toggle-knob"></div>
                        </div>
                    </label>
                </div>

                @if (form.get('arq_parking')?.value === 'true') {
                <div class="form-field">
                    <label>Descripción del parking (Español)</label>
                    <input type="text" formControlName="arq_parking_descripcion_esp" class="form-input"
                        placeholder="Ej: Aparcamiento público gratuito en las inmediaciones">
                </div>
                <div class="form-field">
                    <label>Descripción del parking (Inglés)</label>
                    <input type="text" formControlName="arq_parking_descripcion_ing" class="form-input"
                        placeholder="Ej: Free public parking nearby">
                </div>
                }
            </div>
            }

            <!-- PASO 4: Campos específicos de naturaleza -->
            @if (currentStep === 3 && form.get('categoria')?.value === 'natural') {
            <div class="section-content">
                <div class="form-field">
                    <label>Precio de entrada</label>
                    <input type="number" formControlName="nat_precio_entrada" class="form-input"
                        placeholder="0 si es gratuito" min="0" step="0.01">
                    <p class="field-hint">Introduce 0 si la entrada es gratuita.</p>
                </div>

                <div class="form-field">
                    <label>Origen geológico (Español)</label>
                    <textarea formControlName="nat_origen_geologico_esp" class="form-input form-textarea" rows="3"
                        placeholder="Descripción del origen geológico en español..."></textarea>
                </div>

                <div class="form-field">
                    <label>Origen geológico (Inglés)</label>
                    <textarea formControlName="nat_origen_geologico_ing" class="form-input form-textarea" rows="3"
                        placeholder="Geological origin description in English..."></textarea>
                </div>

                <div class="toggle-grid">
                    <label class="toggle-card" [class.active]="form.get('nat_banos')?.value === 'true'">
                        <span class="toggle-label">Baños</span>
                        <div class="toggle-switch" (click)="toggleField('nat_banos')">
                            <div class="toggle-knob"></div>
                        </div>
                    </label>

                    <label class="toggle-card" [class.active]="form.get('nat_parking')?.value === 'true'">
                        <span class="toggle-label">Parking</span>
                        <div class="toggle-switch" (click)="toggleField('nat_parking')">
                            <div class="toggle-knob"></div>
                        </div>
                    </label>

                    <label class="toggle-card" [class.active]="form.get('nat_oficina_informacion')?.value === 'true'">
                        <span class="toggle-label">Oficina de información</span>
                        <div class="toggle-switch" (click)="toggleField('nat_oficina_informacion')">
                            <div class="toggle-knob"></div>
                        </div>
                    </label>

                    <label class="toggle-card" [class.active]="form.get('nat_restauracion')?.value === 'true'">
                        <span class="toggle-label">Restauración dentro del paraje</span>
                        <div class="toggle-switch" (click)="toggleField('nat_restauracion')">
                            <div class="toggle-knob"></div>
                        </div>
                    </label>
                </div>

                @if (form.get('nat_parking')?.value === 'true') {
                <div class="form-field">
                    <label>Descripción del parking (Español)</label>
                    <input type="text" formControlName="nat_parking_descripcion_esp" class="form-input"
                        placeholder="Ej: Pequeña zona de aparcamiento sin asfaltar">
                </div>
                <div class="form-field">
                    <label>Descripción del parking (Inglés)</label>
                    <input type="text" formControlName="nat_parking_descripcion_ing" class="form-input"
                        placeholder="Ej: Small unpaved parking area near the main access">
                </div>
                }
            </div>
            }

            <!-- PASO 4: Campos específicos de evento -->
            @if (currentStep === 3 && form.get('categoria')?.value === 'evento') {
            <div class="section-content">
                <div class="form-field">
                    <label>Precio de entrada</label>
                    <input type="number" formControlName="evt_precio_entrada" class="form-input"
                        placeholder="0 si es gratuito" min="0" step="0.01">
                    <p class="field-hint">Introduce 0 si la entrada es gratuita.</p>
                </div>

                <div class="form-field">
                    <label>Página web</label>
                    <input type="text" formControlName="evt_web" class="form-input"
                        placeholder="https://ejemplo.com/evento">
                </div>

                <div class="form-field">
                    <label>Mes</label>
                    <div class="select-wrapper">
                        <select formControlName="evt_mes_esp" class="form-input">
                            <option value="">Selecciona mes</option>
                            @for (mes of meses; track mes.value) {
                            <option [value]="mes.value">{{ mes.value }}</option>
                            }
                        </select>
                    </div>
                </div>

                <div class="form-field">
                    <label>Horario (Español)</label>
                    <input type="text" formControlName="evt_horario_esp" class="form-input"
                        placeholder="Ej: 18:00 - 00:00">
                </div>

                <div class="form-field">
                    <label>Horario (Inglés)</label>
                    <input type="text" formControlName="evt_horario_ing" class="form-input"
                        placeholder="Ej: 18:00 - 00:00">
                </div>

                <div class="form-field">
                    <label>Historia (Español)</label>
                    <textarea formControlName="evt_historia_esp" class="form-input form-textarea" rows="3"
                        placeholder="Contexto histórico del evento en español..."></textarea>
                </div>

                <div class="form-field">
                    <label>Historia (Inglés)</label>
                    <textarea formControlName="evt_historia_ing" class="form-input form-textarea" rows="3"
                        placeholder="Historical context of the event in English..."></textarea>
                </div>

                <div class="toggle-grid">
                    <label class="toggle-card" [class.active]="form.get('evt_parking')?.value === 'true'">
                        <span class="toggle-label">Parking</span>
                        <div class="toggle-switch" (click)="toggleField('evt_parking')">
                            <div class="toggle-knob"></div>
                        </div>
                    </label>
                </div>

                @if (form.get('evt_parking')?.value === 'true') {
                <div class="form-field">
                    <label>Descripción del parking (Español)</label>
                    <input type="text" formControlName="evt_descripcion_parking_esp" class="form-input"
                        placeholder="Ej: Zonas habilitadas en calles cercanas">
                </div>
                <div class="form-field">
                    <label>Descripción del parking (Inglés)</label>
                    <input type="text" formControlName="evt_descripcion_parking_ing" class="form-input"
                        placeholder="Ej: Designated parking areas nearby">
                </div>
                }
            </div>
            }

            <!-- Botones de navegación -->
            <div class="form-actions">
                @if (currentStep > 0) {
                <button type="button" class="form-btn secondary-btn" (click)="prevStep()">Anterior</button>
                }

                @if (currentStep < totalSteps - 1) {
                <button type="button" class="form-btn" (click)="nextStep()">Siguiente</button>
                } @else {
                <button type="submit" class="form-btn" [disabled]="isSubmitting">
                    @if (isSubmitting) {
                    <div class="spinner"></div>
                    } @else {
                    <span>Crear maravilla</span>
                    }
                </button>
                }
            </div>
        </form>
        }

    </div>
</div>

@if (showInspectModal && itemToInspect) {
<app-feature-inspect [item]="itemToInspect" (closed)="closeInspectModal()" />
}

@if (showDeleteModal) {
<div class="modal-overlay" (click)="closeDeleteModal()">
    <div class="modal-box" (click)="$event.stopPropagation()">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none"
            stroke="#c0392b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
            <path d="M10 11v6"></path>
            <path d="M14 11v6"></path>
            <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
        </svg>
        <h3>¿Eliminar maravilla?</h3>
        <p>Vas a eliminar <strong>{{ itemToDelete?.denominacion }}</strong>. Esta acción no se puede deshacer.</p>
        <div class="modal-actions">
            <button class="modal-btn cancel-btn" [disabled]="isDeleting" (click)="closeDeleteModal()">Cancelar</button>
            <button class="modal-btn confirm-btn" [disabled]="isDeleting" (click)="confirmDelete()">
                @if (isDeleting) {
                <span class="btn-spinner"></span>
                } @else {
                Eliminar
                }
            </button>
        </div>
    </div>
</div>
}
